import { useSyncExternalStore } from 'react';

function subscribe(query: string, callback: () => void) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
  const mql = window.matchMedia(query);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => subscribe(query, cb),
    () => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
      return window.matchMedia(query).matches;
    },
    () => false,
  );
}

/**
 * Breakpoints canonicos (CLAUDE.md §Plataforma e Ambiente):
 *  - Mobile        : < 900px
 *  - Tablet        : 900-1199 (sidebar colapsada, sem right pane)
 *  - Intermediario : 1200-1439 (sidebar full, right pane em drawer/toggle)
 *  - Desktop       : >= 1440 (triple-pane)
 */
export const useIsMobile = () => useMediaQuery('(max-width: 899px)');
export const useIsTablet = () => useMediaQuery('(min-width: 900px) and (max-width: 1199px)');
export const useIsIntermediate = () => useMediaQuery('(min-width: 1200px) and (max-width: 1439px)');
export const useIsDesktop = () => useMediaQuery('(min-width: 1440px)');
export const useIsAtLeastTablet = () => useMediaQuery('(min-width: 900px)');
